export const cookies = {
  // Cookie-Banner
  banner: {
    title: 'Ihre Privatsphäre ist uns wichtig',
    description: 'Wir verwenden Cookies, um Ihr Surferlebnis zu verbessern, unseren Datenverkehr zu analysieren und unsere Dienste zu optimieren. Durch Klicken auf "Alle akzeptieren" stimmen Sie der Verwendung von Cookies zu.',
    learnMore: 'Mehr erfahren',
    acceptAll: 'Alle akzeptieren',
    rejectAll: 'Alle ablehnen',
    customize: 'Anpassen',
    essentialShort: 'Notwendig',
    analyticsShort: 'Analyse',
    footerNote: 'Sie können Ihre Einstellungen jederzeit über die Fußzeile ändern.',
  },

  // Cookie-Einstellungen Modal
  settings: {
    title: 'Cookie-Einstellungen',
    description: 'Wir verwenden verschiedene Arten von Cookies, um Ihr Erlebnis auf unserer Website zu optimieren. Wählen Sie aus, welche Cookies Sie zulassen möchten.',
    learnMore: 'Cookie-Richtlinie lesen',
    close: 'Schließen',
    cookiesUsed: 'Verwendete Cookies',
    acceptAll: 'Alle akzeptieren',
    rejectAll: 'Nur notwendige',
    save: 'Einstellungen speichern',
    cancel: 'Abbrechen',
    footerNote: 'Ihre Privatsphäre ist uns wichtig. Wir verpflichten uns, Ihre Daten zu schützen.',

    // Notwendige Cookies
    essential: {
      title: 'Notwendige Cookies',
      description: 'Diese Cookies sind für die ordnungsgemäße Funktion der Website erforderlich. Sie ermöglichen grundlegende Funktionen wie Sicherheit, Netzwerkverwaltung und Zugänglichkeit. Diese Cookies können nicht deaktiviert werden.',
      cookies: 'session_id, auth_token, language_preference',
      required: '(Erforderlich)',
    },

    // Analyse-Cookies
    analytics: {
      title: 'Analyse-Cookies',
      description: 'Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, indem Informationen anonym gesammelt und gemeldet werden. Dies hilft uns, unsere Dienste zu verbessern.',
      cookies: '_ga, _ga_*, _gid (Google Analytics 4)',
    },

    // Marketing-Cookies (Zukünftige Verwendung)
    marketing: {
      title: 'Marketing-Cookies',
      description: 'Diese Cookies verfolgen Ihre Online-Aktivitäten, um Werbetreibenden dabei zu helfen, relevantere Werbung zu liefern. Wir verwenden derzeit keine Marketing-Cookies.',
      cookies: 'Derzeit keine',
    },
  },

  // Cookie-Richtlinie Seite
  policy: {
    title: 'Cookie-Richtlinie',
    lastUpdated: '25. Januar 2026',
    lastUpdatedLabel: 'Zuletzt aktualisiert',

    nav: {
      title: 'Inhaltsverzeichnis',
      introduction: 'Einleitung',
      categories: 'Cookie-Kategorien',
      cookiesWeUse: 'Verwendete Cookies',
      googleAnalytics: 'Google Analytics 4',
      yourChoices: 'Ihre Wahlmöglichkeiten',
      contact: 'Kontakt',
    },

    sections: {
      introduction: {
        title: '1. Einleitung',
        content: `
          <p>Diese Cookie-Richtlinie erklärt, wie TerminTeiler („wir", „uns" oder „unser") Cookies und ähnliche Technologien auf unserer Website und zugehörigen Diensten verwendet.</p>
          
          <p>Cookies sind kleine Textdateien, die auf Ihrem Gerät (Computer, Smartphone oder Tablet) gespeichert werden, wenn Sie eine Website besuchen. Sie helfen uns dabei, Ihren Anmeldestatus und Ihre Präferenzen zu speichern, zu verstehen, wie Sie unsere Website nutzen, Ihr Nutzererlebnis zu verbessern und Website-Traffic und -Leistung zu analysieren.</p>
          
          <p>Wir verpflichten uns zu Transparenz und Datenschutz. Diese Richtlinie erklärt, welche Cookies wir verwenden, warum wir sie verwenden und wie Sie sie kontrollieren können.</p>
        `,
      },

      categories: {
        title: '2. Arten von Cookies',
        content: `
          <p>Wir kategorisieren Cookies nach ihrem Zweck und ermöglichen Ihnen die Kontrolle darüber, welche Cookies Sie akzeptieren:</p>
          
          <h3>2.1 Notwendige Cookies (immer aktiv)</h3>
          <p>Diese Cookies sind für die Funktion der Website unbedingt erforderlich. Ohne diese Cookies können angeforderte Dienste nicht bereitgestellt werden. Sie ermöglichen Benutzerauthentifizierung, Sitzungsverwaltung, Spracheinstellungen und grundlegende Funktionalität.</p>
          <p><strong>Rechtsgrundlage:</strong> Berechtigtes Interesse (DSGVO Art. 6 Abs. 1 lit. f) - erforderlich für die Bereitstellung des von Ihnen angeforderten Dienstes.</p>
          
          <h3>2.2 Analyse-Cookies (Einwilligung erforderlich)</h3>
          <p>Diese Cookies sammeln Informationen darüber, wie Sie unsere Website nutzen. Alle Informationen werden aggregiert und anonymisiert. Sie erfassen besuchte Seiten, auf Seiten verbrachte Zeit, Navigationsmuster und Geräte- und Browser-Informationen (anonymisiert).</p>
          <p><strong>Rechtsgrundlage:</strong> Einwilligung (DSGVO Art. 6 Abs. 1 lit. a) - Sie stimmen ihrer Verwendung ausdrücklich zu.</p>
          
          <h3>2.3 Marketing-Cookies (zukünftige Verwendung)</h3>
          <p>Wir verwenden derzeit keine Marketing- oder Werbe-Cookies. Sollten wir uns in Zukunft dafür entscheiden, werden wir diese Richtlinie aktualisieren und Ihre ausdrückliche Einwilligung einholen.</p>
        `,
      },

      cookiesWeUse: {
        title: '3. Detaillierte Cookie-Informationen',
        content: `
          <p>Nachfolgend finden Sie eine vollständige Liste der auf unserer Website verwendeten Cookies:</p>
          
          <h3>3.1 Notwendige Cookies</h3>
          <table>
            <thead>
              <tr>
                <th>Cookie-Name</th>
                <th>Zweck</th>
                <th>Speicherdauer</th>
                <th>Typ</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>session_id</strong></td>
                <td>Erhält Ihre Sitzung während der Navigation auf der Website aufrecht</td>
                <td>Sitzung (wird beim Schließen des Browsers gelöscht)</td>
                <td>Erstanbieter</td>
              </tr>
              <tr>
                <td><strong>auth_token</strong></td>
                <td>Hält Sie zwischen Besuchen angemeldet</td>
                <td>30 Tage oder bis zur Abmeldung</td>
                <td>Erstanbieter</td>
              </tr>
              <tr>
                <td><strong>language_preference</strong></td>
                <td>Speichert Ihre Sprachwahl (DE/EN)</td>
                <td>1 Jahr</td>
                <td>Erstanbieter</td>
              </tr>
              <tr>
                <td><strong>cookieConsent</strong></td>
                <td>Speichert Ihre Cookie-Präferenzen</td>
                <td>6 Monate</td>
                <td>Erstanbieter</td>
              </tr>
            </tbody>
          </table>
          
          <h3>3.2 Analyse-Cookies (Google Analytics 4)</h3>
          <p><strong>Nur gesetzt, wenn Sie Analyse-Cookies zustimmen</strong></p>
          
          <table>
            <thead>
              <tr>
                <th>Cookie-Name</th>
                <th>Zweck</th>
                <th>Speicherdauer</th>
                <th>Typ</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>_ga</strong></td>
                <td>Unterscheidet eindeutige Benutzer</td>
                <td>2 Jahre</td>
                <td>Drittanbieter (Google)</td>
              </tr>
              <tr>
                <td><strong>_ga_*</strong></td>
                <td>Speichert Sitzungsstatus</td>
                <td>2 Jahre</td>
                <td>Drittanbieter (Google)</td>
              </tr>
              <tr>
                <td><strong>_gid</strong></td>
                <td>Unterscheidet Benutzer</td>
                <td>24 Stunden</td>
                <td>Drittanbieter (Google)</td>
              </tr>
            </tbody>
          </table>
        `,
      },

      googleAnalytics: {
        title: '4. Google Analytics 4',
        content: `
          <p>Wir verwenden Google Analytics 4 (GA4), um zu verstehen, wie unsere Website genutzt wird, und um unsere Dienste zu verbessern. GA4 wird nur aktiviert, wenn Sie ausdrücklich in Analyse-Cookies einwilligen.</p>
          
          <h3>Welche Daten sammelt GA4?</h3>
          <ul>
            <li><strong>IP-Adresse:</strong> Automatisch anonymisiert (letztes Oktett entfernt)</li>
            <li><strong>Browser & Geräteinformationen:</strong> Browsertyp, Betriebssystem, Bildschirmgröße</li>
            <li><strong>Besuchte Seiten:</strong> URLs und Seitentitel, die Sie ansehen</li>
            <li><strong>Verweisquelle:</strong> Wie Sie auf unsere Website gelangt sind</li>
            <li><strong>Sitzungsdauer:</strong> Auf unserer Website verbrachte Zeit</li>
            <li><strong>Geografischer Standort:</strong> Land und Stadt (ungefähr, basierend auf anonymisierter IP)</li>
          </ul>
          
          <h3>Datenschutzmaßnahmen</h3>
          <p>Wir haben Google Analytics 4 mit den folgenden datenschutzfreundlichen Einstellungen konfiguriert:</p>
          <ul>
            <li><strong>IP-Anonymisierung:</strong> Aktiviert (DSGVO-Anforderung)</li>
            <li><strong>Google Signals:</strong> Deaktiviert (kein geräteübergreifendes Tracking)</li>
            <li><strong>Anzeigenpersonalisierung:</strong> Deaktiviert (keine Werbenutzung)</li>
            <li><strong>Datenspeicherung:</strong> Maximal 14 Monate</li>
            <li><strong>Datenfreigabe:</strong> Deaktiviert für Google-Produkte und -Dienste</li>
            <li><strong>Auftragsverarbeitungsvertrag:</strong> Mit Google unterzeichnet, einschließlich Standardvertragsklauseln für EU-US-Datentransfers</li>
          </ul>
          
          <p><strong>Datenspeicherung:</strong> Google Analytics-Daten können in der Europäischen Union (Hauptstandort) und den Vereinigten Staaten (mit Standardvertragsklauseln) verarbeitet werden.</p>
          <p>Weitere Informationen: <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer">Google Datenschutzerklärung</a></p>
        `,
      },

      yourChoices: {
        title: '5. Cookie-Kontrolle',
        content: `
          <p>Sie haben die volle Kontrolle darüber, welche Cookies auf Ihrem Gerät gesetzt werden. So verwalten Sie Ihre Cookie-Einstellungen:</p>
          
          <h3>5.1 Verwendung unserer Cookie-Einstellungen</h3>
          <p>Der einfachste Weg, Cookies zu verwalten, ist über unser Cookie-Einstellungsfenster:</p>
          <ol>
            <li>Klicken Sie auf "Cookie-Einstellungen" in der Fußzeile der Website</li>
            <li>Schalten Sie einzelne Cookie-Kategorien ein/aus</li>
            <li>Klicken Sie auf "Einstellungen speichern"</li>
          </ol>
          <p>Ihre Einstellungen werden für 6 Monate gespeichert.</p>
          
          <h3>5.2 Browser-Einstellungen</h3>
          <p>Sie können Cookies auch über Ihre Browser-Einstellungen kontrollieren. Die meisten Browser ermöglichen es Ihnen, Cookies zu blockieren, gespeicherte Cookies zu löschen oder über neue Cookies benachrichtigt zu werden.</p>
          
          <h3>5.3 Deaktivierung von Google Analytics</h3>
          <p>Sie können Google Analytics speziell deaktivieren durch:</p>
          <ul>
            <li>Verwendung unserer Cookie-Einstellungen zur Deaktivierung von Analyse-Cookies</li>
            <li>Installation des <a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank" rel="noopener noreferrer">Google Analytics Deaktivierungs-Browser-Add-ons</a></li>
          </ul>
          
          <p><strong>Hinweis:</strong> Das Blockieren notwendiger Cookies kann verhindern, dass Sie bestimmte Funktionen unserer Website nutzen können, wie z.B. die Anmeldung.</p>
        `,
      },

      contact: {
        title: '6. Fragen zu Cookies?',
        content: `
          <p>Wenn Sie Fragen zur Verwendung von Cookies haben, kontaktieren Sie uns bitte:</p>
          
          <p><strong>TerminTeiler</strong><br/>
          E-Mail: support@terminteiler.com<br/>
          Betreff: "Cookie-Richtlinie Anfrage"<br/>
          Standort: Siegen, Deutschland</p>
          
          <p>Für Informationen über Ihre Rechte gemäß DSGVO in Bezug auf Cookies und über Cookies gesammelte Daten siehe unsere <a href="/privacy-policy">Datenschutzerklärung</a>.</p>
          
          <p>Wenn Sie mit unserem Umgang mit Cookies nicht zufrieden sind, haben Sie das Recht, eine Beschwerde bei der Aufsichtsbehörde einzureichen. Kontaktdaten finden Sie in unserer <a href="/privacy-policy">Datenschutzerklärung</a>.</p>
          
          <hr style="margin: 2rem 0; border: none; border-top: 1px solid #e0e0e0;"/>
          
          <p><strong>Vielen Dank für Ihr Vertrauen in TerminTeiler!</strong></p>
          <p>Wir verpflichten uns, Ihre Daten zu schützen und transparent über unsere Cookie-Verwendung zu informieren.</p>
        `,
      },
    },
  },
};
